import React from "react";
import { Treemap } from "recharts";

const COLORS = [
  "#8889DD",
  "#9597E4",
  "#8DC77B",
  "#A5D297",
  "#E2CF45",
  "#F8C12D",
];

interface TreeMapProps {
  data: {
    name: string;
    value: any;
  }[];
  width?: number;
}

const CustomizedContent = (props: any) => {
  const { depth, x, y, width, height, name, value } = props;

  return (
    <g>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        style={{
          fill:
            depth === 1
              ? COLORS[Math.floor(Math.random() * COLORS.length)]
              : "none",
          stroke: "#fff",
          strokeWidth: 2 / (depth + 1e-10),
          strokeOpacity: 1 / (depth + 1e-10),
        }}
      />
      {depth === 1 ? (
        <text
          x={x + width / 2}
          y={y + height / 2 + 7}
          textAnchor="middle"
          fill="#fff"
          fontSize={11}
        >
          {name}
        </text>
      ) : null}
      {depth === 1 ? (
        <text x={x + 4} y={y + 18} fill="#fff" fontSize={16} fillOpacity={0.9}>
          {value}
        </text>
      ) : null}
    </g>
  );
};

export default function TreeMap({ data = [], width = 600 }: TreeMapProps) {
  const mapData = data.map(({ name, value }) => ({
    name,
    children: [{ name, size: value }],
  }));

  return (
    <Treemap
      width={width}
      height={width / 2}
      data={mapData}
      dataKey="size"
      stroke="#fff"
      fill="#8884d8"
      content={<CustomizedContent colors={COLORS} />}
    />
  );
}
